module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/hockey-8d006f6583b0504feb1e76d0469ce37d.svg";